<template>
    <ac-modal title="Verify your selection" ref="modalRef" :size-class="'modal-lg'" @ac-modal-closed="cancel">
        <template>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12 alert alert-danger">
                        <span>The following employees/dependents are associated to networks/physicians not included in your selection</span>
                    </div>
                </div>
                <div class="row alert alert-danger" v-if="consumerPlans">
                    <div v-for="affectedPlan in consumerPlans" :key="affectedPlan.consumerPlan.consumerId">
                        <span>{{affectedPlan.consumerPlan.consumerName}}</span>, Pysician:
                        <span>{{affectedPlan.consumerPlan.physicianName}}</span>
                        (Associated with <span>{{affectedPlan.mainProviderName}}</span>)
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <h3>Continue and terminate plans</h3>
                        <p>
                            Employees will not be able to associate with any of the physicians excluded from your
                            selection.<br>
                            Plans will be terminated for the employees shown above but they will still be able to
                            receive care
                            from these physicians until the end of the current month, an email will be sent to the
                            employees
                            notifying
                            them about this action.
                        </p>
                    </div>
                    <div class="col-lg-12">
                        <ac-button class="btn btn-warning" :action="saveAndRemovePlans">
                            Continue
                        </ac-button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <h3>Continue and exclude existing networks</h3>
                        <p>
                            Employees will not be able to associate with any of the physicians excluded from your
                            selection.<br>
                            Employees shown above will remain associated to their physicians even when their network
                            is
                            no
                            longer associated.
                        </p>
                    </div>
                    <div class="col-lg-12">
                        <ac-button class="btn btn-info" :action="save">Continue</ac-button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div class="modal-footer">
                        <div class="button-box">
                            <ac-button class="btn btn-sm btn-red" :action="cancel">Cancel</ac-button>
                        </div>
                    </div>
                </div>
            </div>  
            <br/>
        </template>

    </ac-modal>
</template>

<script>
    import {common} from "../../../../global/common.js";
    import {api} from "../../../../global/framework/api.js";

    export default {
        name: "VerifySelectionModal",
        inheritAttrs: false,
        components: {},
        data() {
            return {
                groupData: {},
                consumerPlans: [],
                successReference: true
            };
        },
        methods: {
            async showModal({consumerPlans, groupData}) {
                this.consumerPlans = consumerPlans;
                this.groupData = groupData;
                this.$refs.modalRef.open();
                return new Promise((resolve, reject) => {
                    this.successReference = resolve;
                });
            },
            cancel() {
                this.successReference(false);
                this.closeModal();
            },
            closeModal() {
                this.$refs.modalRef.close();
            },
            async save() {
                let result = await api.post('admin', 'UpdateCompany', this.groupData);
                if(result) {
                    this.successReference(true);
                    this.closeModal();
                }
            },
            async saveAndRemovePlans() {
                let result = await api.post('admin', 'UpdateCompanyAndRemove', this.groupData);
                if(result) {
                    this.successReference(true);
                    this.closeModal();
                }
            }
        }
    }
</script>

<style scoped>
    .modal-footer {
        padding-left: 0;
        padding-right: 0;
    }
</style>